module.exports = __webpack_public_path__ + "img/CNN logo.a0da9d52.jpg";